import { render, staticRenderFns } from "./MesasComandas.vue?vue&type=template&id=180db134&scoped=true"
import script from "./MesasComandas.vue?vue&type=script&lang=js"
export * from "./MesasComandas.vue?vue&type=script&lang=js"
import style0 from "./MesasComandas.vue?vue&type=style&index=0&id=180db134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180db134",
  null
  
)

export default component.exports